import { cn } from '#app/utils/misc'

type TRating = {
	rating: number
	onChange?: (rating: number) => void
	className?: string
}

export default function Rating({ rating, onChange, className }: TRating) {
	const handleClick = (selected: number) => {
		if (!rating && onChange) {
			onChange(selected)
		}
	}

	return (
		<div className={cn('flex gap-2.5', className)}>
			{[...Array(5)].map((_, i) => (
				<svg
					key={i}
					width="14"
					height="14"
					viewBox="0 0 14 14"
					fill="currentColor"
					className={`${i < rating ? 'text-yellow-400' : 'text-gray-300'}`}
					onClick={() => handleClick(i + 1)}
					style={{ cursor: rating ? 'default' : 'pointer' }}
				>
					<path
						id="Vector"
						d="M3.12913 13.4506C2.79461 13.6222 2.41502 13.3215 2.48262 12.9376L3.20193 8.83836L0.148761 5.92992C-0.136362 5.65779 0.0118326 5.16035 0.39402 5.10661L4.63881 4.50343L6.53155 0.753492C6.70228 0.415503 7.16419 0.415503 7.33492 0.753492L9.22766 4.50343L13.4725 5.10661C13.8546 5.16035 14.0028 5.65779 13.7168 5.92992L10.6645 8.83836L11.3839 12.9376C11.4515 13.3215 11.0719 13.6222 10.7373 13.4506L6.93194 11.4955L3.12826 13.4506H3.12913Z"
					/>
				</svg>
			))}
		</div>
	)
}
